import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'tangram-multi-link-input',
  templateUrl: './multi-link-input.component.html',
  styleUrls: ['./multi-link-input.component.scss']
})
export class MultiLinkInputComponent {
  linkInput: string = '';
  links: string[] = [];
  @Output() linksChanged = new EventEmitter<string[]>();

  addLink() {
    const value = (this.linkInput || '').trim();
    if (!value) {
      return;
    }
    this.links.push(value);
    this.linkInput = '';
    this.linksChanged.emit(this.links);
  }

  removeLink(index: number) {
    this.links.splice(index, 1);
    this.linksChanged.emit(this.links);
  }
}
